export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const COTAS_URL = process.env.REACT_APP_COTAS_URL;

export const WHATSAPP_NUMBER = "5511932079525";
export const WHATSAPP_DISPLAY = "(11) 93207-9525";
export const EMAIL = "contato@clubedocontemplado.com.br";

export const waLink = (msg = "Olá! Gostaria de mais informações sobre as cartas contempladas do Clube do Contemplado.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { id: "inicio", label: "Início" },
  { id: "imoveis", label: "Imóveis" },
  { id: "veiculos", label: "Veículos" },
  { id: "vender", label: "Vender minha carta" },
  { id: "quem-somos", label: "Quem somos" },
  { id: "contato", label: "Contato" },
];
